import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Timetable Committee" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        
                        <Row>

                                <Col md={3} className='c-left custom-padding-color mb-4'>
                                <Committeeleft></Committeeleft>
                                </Col>

                                <Col md={9} className='c-right'>


                           
                                <h3 className='c-headline mb-3'>Timetable Committee</h3>
                                <p className='fw-bold caboutus c-lineheight2dot5'>A Committee for the Timetable has been constituted with the following members to into the preparation of the Academic Timetable of the Institute. </p>

                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Dr. Anup Basak</p>
                                                <p>Assistant Professor - Department of Mechanical Engineering</p>
                                            </td>
                                            <td>Chairperson</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Rajib Biswas</p>
                                                <p>Associate Professor - Department of Chemistry</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Avadh Bihari Narayan</p>
                                                <p>Assistant Professor - Department of Civil & Environmental Engineering</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Shamik Mishra</p>
                                                <p>Assistant Professor - Department of Chemical Engineering</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Vaneet Kashyap</p>
                                                <p>Assistant Professor - Department of Humanities and Social Sciences</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Dr. Shilpak Banerjee</p>
                                                <p>Assistant Professor - Department of Mathematics and Statistics</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Dr. Murari Singh</p>
                                                <p>Assistant Professor - Department of Physics</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Dr. Vikramkumar Pudi</p>
                                                <p>Assistant Professor - Department of Electrical Engineening</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Dr. Ajin George Joseph</p>
                                                <p>Assistant Professor - Department of Computer Science and Engineening</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Student General Secretary</p>
                                                <p></p>
                                            </td>
                                            <td>Invitee</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Academics Affairs Secretary</p>
                                                <p></p>
                                            </td>
                                            <td>Invitee</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Mr. Harikrishna Reddy</p>
                                                <p>Assistant Registrar - Academic Courses</p>
                                            </td>
                                            <td>Secretary</td>
                                        </tr>
                                    </tbody>

                                </Table>

                               <h3 className='c-headline mt-5 mb-3'>The Role of the Committee:</h3>
                                <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />The Committee is to prepare the timetable for all the courses offered at the Institute including allotment of classrooms and other relevant details</li>
                                </ul>

                            </Col>

                            
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;